import {
  UpdatePersonalInfo,
  useUpdatePersonalInfo,
} from '@/components/PageForm/PersonalDetails';

import { useTranslate } from '@/hooks/useTranslate';

import { UpdatePersonalInfoDrawerStyled } from './UpdatePersonalInfoDrawer.styled';

type UpdatePersonalInfoDrawerProps = {
  open: boolean;
  onClose: () => void;
  isLoading?: boolean;
  onSuccess?: () => void;
};

export function UpdatePersonalInfoDrawer({
  open,
  onClose,
  isLoading = false,
  onSuccess,
}: Readonly<UpdatePersonalInfoDrawerProps>) {
  const { t } = useTranslate();

  const onCloseDrawer = () => {
    resetForm(undefined);
    onClose();
  };

  const {
    methods,
    onConfirm,
    onSubmit,
    isPending,
    isValid,
    isOpenConfirmPopup,
    closeConfirmPopup,
    resetForm,
  } = useUpdatePersonalInfo({
    triggerFormValidation: open,
    onSuccess: onSuccess ?? onCloseDrawer,
  });

  return (
    <UpdatePersonalInfoDrawerStyled
      open={open}
      onClose={onCloseDrawer}
      title={t('moreInfo.reviewPersonalInfo.drawer.updatePersonalInfo.title')}
    >
      <UpdatePersonalInfo
        methods={methods}
        onConfirm={onConfirm}
        onSubmit={onSubmit}
        isPending={isPending || isLoading}
        isValid={isValid}
        isOpenConfirmPopup={isOpenConfirmPopup}
        closeConfirmPopup={closeConfirmPopup}
      />
    </UpdatePersonalInfoDrawerStyled>
  );
}
